module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-982036d7.png";